export enum LoadIndicatorSizeEnum {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}
